/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgTime = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M12 19.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15m0 1.5a9 9 0 1 1 0-18 9 9 0 0 1 0 18" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M12.75 12.228V7h-1.5v5.228c0 .727.35 1.409.942 1.831l2.872 2.051.872-1.22-2.872-2.052a.75.75 0 0 1-.314-.61" clipRule="evenodd" /></svg>;
export default SvgTime;